import { render, staticRenderFns } from "./AbsenceTypeField.vue?vue&type=template&id=d08c4dfa&scoped=true&"
import script from "./AbsenceTypeField.vue?vue&type=script&lang=js&"
export * from "./AbsenceTypeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08c4dfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d08c4dfa')) {
      api.createRecord('d08c4dfa', component.options)
    } else {
      api.reload('d08c4dfa', component.options)
    }
    module.hot.accept("./AbsenceTypeField.vue?vue&type=template&id=d08c4dfa&scoped=true&", function () {
      api.rerender('d08c4dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/absences/fields/AbsenceTypeField.vue"
export default component.exports